import { render } from "./new-client.vue?vue&type=template&id=17a7d215&scoped=true"
import script from "./new-client.vue?vue&type=script&lang=js"
export * from "./new-client.vue?vue&type=script&lang=js"

import "./new-client.vue?vue&type=style&index=0&id=17a7d215&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a7d215"]])

export default __exports__